module.exports = __webpack_public_path__ + "website/img/VIP_bottom.85e1adae.svg";